/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './custom-menu.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '@angular/router';
import * as i4 from '../../../../app/shared/custom-menu/custom-menu.component';
import * as i5 from '../../../../app/shared/settings.service';
import * as i6 from '../../../../app/auth/current-user';
const styles_CustomMenuComponent:any[] = [i0.styles];
export const RenderType_CustomMenuComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CustomMenuComponent,data:{}});
function View_CustomMenuComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'a',([] as any[]),
      [[8,'href',4]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(278528,
      (null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.toSnakeCase((<any>(<any>_v.parent).parent).context.$implicit.label);
    _ck(_v,1,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',(<any>(<any>_v.parent).parent).context.$implicit.action,
        '');
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = (<any>(<any>_v.parent).parent).context.$implicit.label;
    _ck(_v,2,0,currVal_2);
  });
}
function View_CustomMenuComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'a',([] as any[]),
      [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i1.ɵdid(671744,(null as any),0,i3.RouterLinkWithHref,[i3.Router,i3.ActivatedRoute,
          i2.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),(_l()(),
          i1.ɵted((null as any),['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.toSnakeCase((<any>(<any>_v.parent).parent).context.$implicit.label);
    _ck(_v,1,0,currVal_2);
    const currVal_3:any = i1.ɵinlineInterpolate(1,'',('/' + (<any>(<any>_v.parent).parent).context.$implicit.action),
        '');
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2).target;
    const currVal_1:any = i1.ɵnov(_v,2).href;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_4:any = (<any>(<any>_v.parent).parent).context.$implicit.label;
    _ck(_v,3,0,currVal_4);
  });
}
function View_CustomMenuComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'a',([] as any[]),
      [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i1.ɵdid(671744,(null as any),0,i3.RouterLinkWithHref,[i3.Router,i3.ActivatedRoute,
          i2.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),(_l()(),
          i1.ɵted((null as any),['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.toSnakeCase((<any>(<any>_v.parent).parent).context.$implicit.label);
    _ck(_v,1,0,currVal_2);
    const currVal_3:any = i1.ɵinlineInterpolate(1,'',('/pages/' + (<any>(<any>_v.parent).parent).context.$implicit.action),
        '');
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2).target;
    const currVal_1:any = i1.ɵnov(_v,2).href;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_4:any = (<any>(<any>_v.parent).parent).context.$implicit.label;
    _ck(_v,3,0,currVal_4);
  });
}
function View_CustomMenuComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CustomMenuComponent_3)),i1.ɵdid(16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CustomMenuComponent_4)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomMenuComponent_5)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    ']))],(_ck,
      _v) => {
    const currVal_0:any = ((<any>_v.parent).context.$implicit.type === 'link');
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = ((<any>_v.parent).context.$implicit.type === 'route');
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = ((<any>_v.parent).context.$implicit.type === 'page');
    _ck(_v,9,0,currVal_2);
  },(null as any));
}
function View_CustomMenuComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'nav-item custom-menu-item']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CustomMenuComponent_2)),i1.ɵdid(16384,
      (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.shouldShow(_v.context.$implicit);
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_CustomMenuComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_CustomMenuComponent_1)),i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n\n'])),i1.ɵncd((null as any),0)],(_ck,_v) => {
    var _co:i4.CustomMenuComponent = _v.component;
    const currVal_0:any = _co.menu.items;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_CustomMenuComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'custom-menu',
      ([] as any[]),[[2,'hidden',(null as any)]],(null as any),(null as any),View_CustomMenuComponent_0,
      RenderType_CustomMenuComponent)),i1.ɵdid(245760,(null as any),0,i4.CustomMenuComponent,
      [i5.SettingsService,i6.CurrentUser],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).shouldHide;
    _ck(_v,0,0,currVal_0);
  });
}
export const CustomMenuComponentNgFactory:i1.ComponentFactory<i4.CustomMenuComponent> = i1.ɵccf('custom-menu',
    i4.CustomMenuComponent,View_CustomMenuComponent_Host_0,{position:'position'},{},
    ['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/custom-menu/custom-menu.component.ngfactory.ts